/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import moment from 'moment';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import Form from 'forms/_.extend';
import Loading from 'components/Loading/Loading';
import ActionDrawerHeader from 'views/ActionDrawer/components/ActionDrawerHeader/ActionDrawerHeader';

import RequestOwnershipMultiForm from './RequestOwnershipMultiForm/RequestOwnershipMultiForm';
import RequestOwnershipMultiSuccess from './RequestOwnershipMultiSuccess/RequestOwnershipMultiSuccess';
import RequestOwnershipMultiError from './RequestOwnershipMultiError/RequestOwnershipMultiError';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {
  t: TranslatorProps,
  actionDrawerStore: TypeActionDrawerStore,
};

@translate()
@inject('actionDrawerStore')
@observer
export default class RequestOwnershipMulti extends React.Component<*> {
  createForm: Function = () => {
    const { t, actionDrawerStore }: TypeProps = this.props;

    const asset: Object = this.props.formData;

    // let currentEndDate: Date = new Date();
    //
    // const currentEndDate: Date = new Date(Math.max.apply(null, project.map(function (p) {
    //     return new Date(p.end_date);
    // })));
    //
    // if (asset.contract && asset.contract.er_end_date) {
    //     currentEndDate = moment(asset.contract.er_end_date, 'YYYY-MM-DD').toDate();
    // }

    const fields: Array<Object> = [
      {
        name: 'requestReason',
        label: t('general:assets.reasons.why_request_ownership'),
        fields: [
          {
            name: 'reason',
            label: t('general:reasons.reason_for_wanting_ownership'),
            rules: 'required|string',
            value: '',
            options: [
              {
                id: '1',
                label: t('general:reasons.currently_using_assets'),
              },
              {
                id: '2',
                label: t('general:reasons.need_assets_for_test'),
              },
              {
                id: '3',
                label: t('general:reasons.assets_owner'),
              },
              {
                id: 'other',
                label: t('general:reasons.options.other'),
              },
            ],
          },
        ],
      },
    ];

    const activeUser: Object = JSON.parse(localStorage.getItem('user'));

    const hooks: Object = {
      onSuccess(data: Object) {
        const assetIds = asset.map(a => a.id);

        const { reason } = data.values().requestReason;

        actionDrawerStore.requestOwnershipMulti({
          reason,
          assignee_id: activeUser.id,
          asset_ids: assetIds,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        name: 'requestOwnershipMulti',
      }
    );
  };

  render(): React.Node {
    const { t, actionDrawerStore }: TypeProps = this.props;

    const asset: Object = this.props.formData;

    const title: string = t('general:actions.request_ownership_of_asset_plural');

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={title} />
          <RequestOwnershipMultiError asset={asset} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={title} />
          <RequestOwnershipMultiSuccess response={actionDrawerStore.response} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={title} />
        <RequestOwnershipMultiForm asset={asset} form={this.createForm()} />
      </div>
    );
  }
}
